export default {
  MY_TIME_OFF: {
    TITLE: 'My Time Off',
    SUMMARY: ''
  },
  CREATE_REQUEST: 'Create a time off request',
  TIME_OFF_ON: '<0>{{vacationTypeName}}</0> on <1></1>',
  APPROVED: 'Approved',
  COMMENT: `comment`,
  COMMENTS: `comments`,
  NO_TIME_OFF: `No time off to display.`
}
